<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <div>
            <v-text-field v-model="fields['titleFaq']" label="Title" />
          </div>
          <v-row>
            <v-col cols="12" md="12">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="head"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields.backgroundContainer"
                  @change="event => handleChangeBgContainer(event)"
                />
                <v-text-field v-model="fields.backgroundContainer" label="Container Background Color" />
              </div>
            </v-col>
          </v-row>
        </div>
        <div>
          <!-- list item -->
          <div class="wrap-products-form">
            <div class="d-flex justify-space-between align-center mb-2">
              <label class="label-input" style="margin-bottom: 10px">List FAQ</label>
              <v-btn small color="primary" @click="handleAddFAQ">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add FAQ</span>
              </v-btn>
            </div>
            <v-row>
              <v-col cols="12" md="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="head"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.backgroundItems"
                    @change="event => handleChangeBgItems(event)"
                  />
                  <v-text-field v-model="fields.backgroundItems" label="Item Background Color" />
                </div>
              </v-col>
            </v-row>
            <div>
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="(item, i) in fields['listItem']" :key="i">
                  <v-expansion-panel-header>
                    <div class="d-flex justify-space-between align-center">
                      <span>Item {{ i + 1 }}</span>
                      <v-btn icon @click.stop="handleRemoveItem(i)">
                        <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="wrap-faq-form">
                      <v-text-field v-model="item.question" label="Question" />
                      <div>
                        <label>Answer</label>
                        <ckeditor :editor="editor" v-model="item.answer" :config="editorConfig" />
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'question-and-answer-grid-section-editor',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        backgroundContainer: '',
        backgroundItems: '',
        titleFaq: '',
        topPadding: true,
        bottomPadding: true,
        listItem: [
          // {
          //   background: '',
          //   question: '',
          //   answer: ''
          // }
        ],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionFaqGrid(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeBgItems(event) {
      this.fields['backgroundItems'] = event.target.value;
    },
    handleRemoveItem(index) {
      this.fields['listItem'].splice(index, 1);
    },
    handleAddFAQ() {
      this.fields['listItem'].push({
        question: 'New Question',
        answer: 'New Answer',
      });
    },
    handleChangeBgContainer(event) {
      this.fields['backgroundContainer'] = event.target.value;
    },
    // handleChangeTextColor(event) {
    //   this.fields['text-color'] = event.target.value
    // },
    // handleChangeBackgroundColor(event) {
    //   this.fields['background-color'] = event.target.value
    // },
    // handleResetBackgroundColor() {
    //   this.fields['background-color'] = ''
    // },
  },
};
</script>

<style lang="css" scoped>
.wrap-faq-form ::v-deep(.ck-editor__editable_inline) {
  min-height: 200px !important;
}
.wrap-faq-form ::v-deep(.ck-editor__editable) {
  min-height: 200px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
